// extracted by mini-css-extract-plugin
export default {"shadow":"shadowbottom_shadow__rvMQo","long":"shadowbottom_long__+Y633"};